import React from 'react';

const JoinPdfs = () => {
    return (
        <div>
            <h2>Join Pdfs</h2>
            <p>Specify files:</p>
            <p>Under construction</p>
        </div>
    )
}

export default JoinPdfs;